export default "__VITE_ASSET__CRPgr7wY__"